import MainPage from "./MainPage/MainPage";
import Cookies from "./Pages/Cookies";

const getRoutes = () => {
    return [{
        index: true,
        element: <MainPage />,
    },
    {
        path: "cookies",
        element: <Cookies />,
    },];
};
export default getRoutes;
